import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { shouldSkipGlobalScrollToTop } from "../navigation/scrollRestorePolicy";

/**
 * Scrolls the window to the top on route changes unless `shouldSkipGlobalScrollToTop` says otherwise.
 * Uses `history.scrollRestoration = 'manual'` so the browser does not fight explicit restores.
 *
 * Runs in `useEffect` (after layout effects) so pages that restore scroll in `useLayoutEffect`
 * (e.g. job search) keep their position.
 */
export default function ScrollToTop() {
  const location = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (typeof window === "undefined" || !("scrollRestoration" in window.history)) return;
    const prev = window.history.scrollRestoration;
    window.history.scrollRestoration = "manual";
    return () => {
      window.history.scrollRestoration = prev;
    };
  }, []);

  useEffect(() => {
    if (shouldSkipGlobalScrollToTop(location, navigationType)) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [location, navigationType]);

  return null;
}
